<template>
  <fieldset>
    <legend class="form__label">{{ name }}</legend>
    <div v-for="option in options" :key="option.value" class="mr-32 my-8">
      <poppins-radio-button
        :id="`radio-${option.value}`"
        :data-test-id="option.value"
        :radioName="name"
        :labelName="option.label"
        :radioValue="option.value"
        :checked="value === option.value"
        @input="radioSelection"
      />
      <HelperText v-if="option.helperText" :text="option.helperText" class="ml-28 mt-4" />
    </div>
  </fieldset>
</template>

<script lang="ts">
import PoppinsRadioButton from '../radio_button/RadioButton.vue';
import HelperText from '../helper_text/HelperText.vue';
import helperStatus from '../../helpers/status';

export default {
  name: 'RadioButtonGroup',
  components: { PoppinsRadioButton, HelperText },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => Array<{ value: string; label: string; helperText?: string }>,
      required: true,
    },
    status: {
      type: Number as () => helperStatus,
      default: helperStatus.Neutral,
    },
  },
  methods: {
    radioSelection(value: string): any {
      return this.$emit('input', value);
    },
  },
};
</script>
